class ReadMore extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
  }

  handleTrigger () {
    const isHidden =
      this.els.extra.element.getAttribute('aria-hidden') === 'true'

    this.els.snippet.element.setAttribute('aria-hidden', isHidden)
    this.els.extra.element.setAttribute('aria-hidden', !isHidden)

    this.els.trigger.elements.forEach((triggerEl) => {
      triggerEl.innerText = isHidden
        ? triggerEl.dataset.less
        : triggerEl.dataset.more
    })
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore)
}
